<template>
  <div class="follow-list-item">
    <!-- moved to insights/components/Common/FollowListItem.vue -->
  </div>
</template>

<script>
import SvgIcon from 'vue-svgicon/dist/components/svgicon.common'

import '../../icons/components/settings'

export default {
  components: {
    SvgIcon,
  },
  props: {
    image: {
      type: String,
      required: true,
    },

    /**
     * Set the placement of button. 'bottom' or 'right' (default)
     */
    buttonPlacement: {
      type: String,
      default: 'right',
      validator: (value) => ['bottom', 'right'].indexOf(value) !== -1,
    },
  },
}
</script>

<style lang="scss" scoped>


.follow-list-item {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  // margin-bottom: 0.5rem;

  &-content {
    display: flex;
    align-items: center;
    width: 100%;
  }

  &-body {
    flex-grow: 1;
    color: $gray-900;
    font-size: $font-size-sm;
    align-self: flex-start;
  }

  &-image {
    margin-right: 1rem;
  }

  > button {
    margin-left: 4rem;
  }
}
</style>
